<div class="site-text">
  <p class="text">
    Would you like to enhance your company’s electronic invoice exchange with your business partners? eDirectory.ch lists all companies and organizations that use e-invoicing in cooperation with a service provider that participates in eDirectory.ch.
  </p>
  <p class="text">
    eDirectory.ch supports you in identifying business partners domiciled in Switzerland who wish to send and/or receive e-bills.
  </p>
  <p class="text">
    The directory of the swissDIGIN forum is operated by PostFinance Ltd and is helping to spread electronic invoice exchange in Switzerland.
  </p>
</div>